import React from 'react';
import { Box, Typography, Button, Link } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {  Visibility } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useNavigate } from 'react-router-dom';

// Funzione per formattare la data come '15-lug-25'
const formatDate = (date) => {
  if (!date) return 'N/A';
  return dayjs(date).locale('it').format('DD-MMM-YY').toLowerCase();
};
const CourseManagementTeacher = ({ courses, enrollments = [] }) => {
  const navigate = useNavigate();
  
  const handleCourseClick = (courseId) => {
    if (courseId) {
      navigate(`/teacher/course/${courseId}`);
    }
  };

  // Colonne definite qui dentro
  const courseColumns = [
    { 
      field: 'name', 
      headerName: 'Nome Corso', 
      flex: 1, 
      minWidth: 180, 
      resizable: true,
      renderCell: (params) => {
        const courseName = params.value || 'N/A';
        
        if (courseName !== 'N/A') {
          return (
            <Link
              component="button"
              variant="body2"
              onClick={() => handleCourseClick(params.row._id)}
              sx={{
                color: '#1976d2', // Classic blue link color
                cursor: 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  color: '#1565c0', // Darker blue on hover
                  textDecoration: 'underline'
                }
              }}
            >
              {courseName}
            </Link>
          );
        }
        return courseName;
      }
    },
    { field: 'venue', headerName: 'Sede', flex: 1, minWidth: 120, resizable: true },
    {
      field: 'minLevel',
      headerName: 'Anno',
      flex: 0.8,
      minWidth: 120,
      resizable: true,
      renderCell: (params) => {
        if (!params.value) {
          return 'Libero';
        }
        if (params.value >= 6) {
          return 'Oltre il 5° anno';
        }
        return `${params.value}° anno`;
      },
    },
    {
      field: 'posti',
      headerName: 'Posti',
      flex: 0.7, minWidth: 100, resizable: true,
      // renderCell: (params) => {
      //   const occupied = params.row.occupiedSeats ?? 0;
      //   const total = params.row.availableSeats ?? 0;
      //   return `${occupied}/${total}`;
      // }
      renderCell: (params) => `${params.row.occupiedSeats}/${params.row.availableSeats}`,
    },
    {
      field: 'startDate',
      headerName: 'Data Inizio',
      flex: 0.8, minWidth: 110, resizable: true,
      renderCell: (params) => formatDate(params.value)
    },
    {
      field: 'endDate',
      headerName: 'Data Fine',
      flex: 0.8, minWidth: 110, resizable: true,
      renderCell: (params) => formatDate(params.value)
    },
    {
      field: 'time',
      headerName: 'Orario',
      flex: 0.7, minWidth: 100, resizable: true,
      renderCell: (params) => params.value || 'N/A'
    },
    {
      field: 'actions',
      headerName: 'Azioni',
      flex: 0.5, minWidth: 80, resizable: true,
      renderCell: (params) => (
        <Button
          size="small"
          onClick={() => params?.row && navigate(`/teacher/course/${params.row._id}`)}
          disabled={!params?.row}
        >
          <Visibility />
        </Button>
      )
    }
  ];

  // console.log('courses', courses);
  // console.log('enrollments', enrollments);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">I Miei Corsi</Typography>
      </Box>
      <DataGrid
        rows={courses}
        columns={courseColumns}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 25, page: 0 },
          },
        }}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
        hideFooterPagination={courses.length <= 10}
      />
    </Box>
  );
};

export default CourseManagementTeacher; 